import React from 'react';
import PropTypes from 'prop-types';
import '../../styles/icon.scss';

export const IconFlash = ({ size }) => {
    return (
        <div className="icon icon12" style={{ width: `${size}px`, height: `${size}px` }}>
            <svg
                style={{ width: `${size}px`, height: `${size}px` }}
                width="8px"
                height="12px"
                viewBox="0 0 8 12"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xlinkHref="http://www.w3.org/1999/xlink"
            >
                <g id="Курс_прохождение" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g id="Home_0" transform="translate(-153.000000, -220.000000)">
                        <g id="Group-Copy" transform="translate(12.000000, 100.000000)">
                            <g id="Group">
                                <g id="button" transform="translate(126.000000, 111.000000)">
                                    <g id="flash" transform="translate(11.000000, 7.000000)">
                                        <rect id="Bounds" x="0" y="0" width="16" height="16" />
                                        <path
                                            d="M6.51597272,12.7438515 C6.17419292,14.1203637 6.68734207,14.4055299 7.60532547,13.4005852 L11.4613785,8.96982087 C12.3535455,7.8808642 12.1300862,7.0059438 10.8452805,6.78721787 L8.98611207,6.44291019 C8.87750193,6.42279619 8.8057616,6.31844465 8.8258756,6.2098345 C8.82653927,6.20625107 8.82730067,6.20268645 8.82815913,6.19914463 L9.54361353,3.24719783 C9.88635213,1.86194511 9.31509787,1.61107807 8.4582164,2.59275159 C7.22701253,3.98097123 6.29137544,5.02966177 5.65130514,5.73882318 C5.42814827,5.98606827 5.06894462,6.37198749 4.57369417,6.89658087 C3.48829707,8.10101647 4.05955136,8.97451053 5.31498713,9.19323647 L7.09177693,9.5117472 C7.2005008,9.5312372 7.27283907,9.63517513 7.253349,9.74389893 C7.2525988,9.74808407 7.25171533,9.7522442 7.25069987,9.75637293 L6.51597272,12.7438515 Z"
                                            id="Mask"
                                            fill="#000000"
                                            fillRule="nonzero"
                                        />
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </svg>
        </div>
    );
};
IconFlash.propTypes = {
    size: PropTypes.number,
};

export const IconList = ({ onClick }) => {
    return (
        <div className="icon icon16" onClick={onClick}>
            <svg
                width="13px"
                height="11px"
                viewBox="0 0 13 10"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xlinkHref="http://www.w3.org/1999/xlink"
            >
                <defs>
                    <path
                        d="M2.66666667,7 C2.11333333,7 1.66666667,7.44666667 1.66666667,8 C1.66666667,8.55333333 2.11333333,9 2.66666667,9 C3.22,9 3.66666667,8.55333333 3.66666667,8 C3.66666667,7.44666667 3.22,7 2.66666667,7 L2.66666667,7 Z M2.66666667,3 C2.11333333,3 1.66666667,3.44666667 1.66666667,4 C1.66666667,4.55333333 2.11333333,5 2.66666667,5 C3.22,5 3.66666667,4.55333333 3.66666667,4 C3.66666667,3.44666667 3.22,3 2.66666667,3 L2.66666667,3 Z M2.66666667,11 C2.11027569,11 1.66666667,11.4511278 1.66666667,12 C1.66666667,12.5488722 2.11779449,13 2.66666667,13 C3.21553885,13 3.66666667,12.5488722 3.66666667,12 C3.66666667,11.4511278 3.22305764,11 2.66666667,11 L2.66666667,11 Z M14,12 L14,12 C14,11.6318102 13.7015232,11.3333333 13.3333333,11.3333333 L5.33333333,11.3333333 C4.9651435,11.3333333 4.66666667,11.6318102 4.66666667,12 L4.66666667,12 C4.66666667,12.3681898 4.9651435,12.6666667 5.33333333,12.6666667 L13.3333333,12.6666667 C13.7015232,12.6666667 14,12.3681898 14,12 Z M14,8 L14,8 C14,7.63181017 13.7015232,7.33333333 13.3333333,7.33333333 L5.33333333,7.33333333 C4.9651435,7.33333333 4.66666667,7.63181017 4.66666667,8 L4.66666667,8 C4.66666667,8.36818983 4.9651435,8.66666667 5.33333333,8.66666667 L13.3333333,8.66666667 C13.7015232,8.66666667 14,8.36818983 14,8 Z M5.33333333,4.66666667 L13.3333333,4.66666667 C13.7015232,4.66666667 14,4.36818983 14,4 L14,4 C14,3.63181017 13.7015232,3.33333333 13.3333333,3.33333333 L5.33333333,3.33333333 C4.9651435,3.33333333 4.66666667,3.63181017 4.66666667,4 L4.66666667,4 C4.66666667,4.36818983 4.9651435,4.66666667 5.33333333,4.66666667 Z"
                        id="iconList"
                    />
                </defs>
                <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g id="Component/Item/Course" transform="translate(-352.000000, -37.000000)">
                        <g id="Icons-24/list_24">
                            <g transform="translate(351.000000, 34.000000)">
                                <g id="list_24">
                                    <polygon id="Bounds" opacity="0.4" points="0 0 16 0 16 16 0 16" />
                                    <mask id="mask-2" fill="white">
                                        <use xlinkHref="#iconList" />
                                    </mask>
                                    <use id="Icon" fill="#AAAEB3" fillRule="nonzero" xlinkHref="#iconList" />
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </svg>
        </div>
    );
};
IconList.propTypes = {
    onClick: PropTypes.func,
};

export const IconList24 = () => {
    return (
        <div className="icon icon24">
            <svg
                width="19px"
                height="16px"
                viewBox="0 0 19 16"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xlinkHref="http://www.w3.org/1999/xlink"
            >
                <desc>Created with Sketch.</desc>
                <defs>
                    <path
                        d="M4,10.5 C3.17,10.5 2.5,11.17 2.5,12 C2.5,12.83 3.17,13.5 4,13.5 C4.83,13.5 5.5,12.83 5.5,12 C5.5,11.17 4.83,10.5 4,10.5 L4,10.5 Z M4,4.5 C3.17,4.5 2.5,5.17 2.5,6 C2.5,6.83 3.17,7.5 4,7.5 C4.83,7.5 5.5,6.83 5.5,6 C5.5,5.17 4.83,4.5 4,4.5 L4,4.5 Z M4,16.5 C3.16541353,16.5 2.5,17.1766917 2.5,18 C2.5,18.8233083 3.17669173,19.5 4,19.5 C4.82330827,19.5 5.5,18.8233083 5.5,18 C5.5,17.1766917 4.83458647,16.5 4,16.5 L4,16.5 Z M21,18 L21,18 C21,17.4477153 20.5522847,17 20,17 L8,17 C7.44771525,17 7,17.4477153 7,18 L7,18 C7,18.5522847 7.44771525,19 8,19 L20,19 C20.5522847,19 21,18.5522847 21,18 Z M21,12 L21,12 C21,11.4477153 20.5522847,11 20,11 L8,11 C7.44771525,11 7,11.4477153 7,12 L7,12 C7,12.5522847 7.44771525,13 8,13 L20,13 C20.5522847,13 21,12.5522847 21,12 Z M8,7 L20,7 C20.5522847,7 21,6.55228475 21,6 L21,6 C21,5.44771525 20.5522847,5 20,5 L8,5 C7.44771525,5 7,5.44771525 7,6 L7,6 C7,6.55228475 7.44771525,7 8,7 Z"
                        id="IconList24"
                    />
                </defs>
                <g id="Курс_старт" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g id="Course" transform="translate(-18.000000, -1006.000000)">
                        <g id="item" transform="translate(0.000000, 990.000000)">
                            <g id="Icons-24/list_24" transform="translate(16.000000, 12.000000)">
                                <g id="list_24">
                                    <polygon id="Bounds" opacity="0.4" points="0 0 24 0 24 24 0 24" />
                                    <mask id="mask-2" fill="white">
                                        <use xlinkHref="#IconList24" />
                                    </mask>
                                    <use id="Icon" fill="#AAAEB3" fillRule="nonzero" xlinkHref="#IconList24" />
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </svg>
        </div>
    );
};

export const IconBullet = ({ size }) => {
    return (
        <div className="icon icon12" style={{ width: `${size}px`, height: `${size}px` }}>
            <svg
                width="16px"
                height="16px"
                viewBox="0 0 12 12"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xlinkHref="http://www.w3.org/1999/xlink"
            >
                <g id="Курс_старт" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g id="Course" transform="translate(-12.000000, -875.000000)">
                        <g id="Group-3" transform="translate(0.000000, 861.000000)">
                            <g id="Group-6" transform="translate(12.000000, 10.000000)">
                                <g id="ic/12/bullet" transform="translate(0.000000, 4.000000)">
                                    <g id="ic/12/done" fill="#5383BA">
                                        <circle id="Oval" cx="6" cy="6" r="6" />
                                    </g>
                                    <g id="noun_Star_1224949" transform="translate(2.000000, 2.000000)" fill="#FFFFFF">
                                        <g id="Group" fillRule="nonzero">
                                            <path
                                                d="M3.618981,7.20962226 L2.69892353,5.30107452 L0.790377695,4.38101868 C0.579946683,4.27957586 0.491594301,4.02675216 0.593037127,3.81632114 C0.634597232,3.73010968 0.704165968,3.66054089 0.790377405,3.61898072 L2.69892353,2.69892294 L3.61898107,0.79037686 C3.72042403,0.579945916 3.97324779,0.491593704 4.18367874,0.593036671 C4.2698901,0.634596798 4.3394588,0.704165497 4.38101893,0.790376863 L5.30107645,2.69892294 L7.20962259,3.61898072 C7.42005352,3.7204237 7.50840571,3.97324747 7.40696273,4.1836784 C7.36540256,4.26988984 7.29583377,4.33945858 7.2096223,4.38101868 L5.30107645,5.30107452 L4.38101899,7.20962225 C4.27957611,7.42005324 4.02675238,7.50840554 3.8163214,7.40696266 C3.73010992,7.36540251 3.66054114,7.29583373 3.618981,7.20962226 Z"
                                                id="Path"
                                            />
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </svg>
        </div>
    );
};
IconBullet.propTypes = {
    size: PropTypes.number,
};

export const IconBulletFlash = ({ size }) => {
    return (
        <div className="icon icon12" style={{ width: `${size}px`, height: `${size}px` }}>
            <svg
                width="16px"
                height="16px"
                viewBox="0 0 12 12"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xlinkHref="http://www.w3.org/1999/xlink"
            >
                <g id="ic/12/bullet-2" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g id="ic/12/done" fill="#5181B8">
                        <circle id="Oval" cx="6" cy="6" r="6" />
                    </g>
                    <g
                        id="noun_bolt_1345495"
                        transform="translate(3.500000, 2.000000)"
                        fill="#FFFFFF"
                        fillRule="nonzero"
                    >
                        <path
                            d="M4.78076923,3.33142857 C4.74615385,3.27352381 4.68307692,3.23809524 4.61538462,3.23809524 L2.88461538,3.23809524 L2.88461538,0.380952381 C2.88461538,0.293714286 2.825,0.217904762 2.74,0.196571429 C2.655,0.175238095 2.56576923,0.213714286 2.52384615,0.289904762 L0.216153846,4.48038095 C0.183846154,4.53904762 0.185,4.61104762 0.219615385,4.66857143 C0.253846154,4.72647619 0.316923077,4.76190476 0.384615385,4.76190476 L2.11538462,4.76190476 L2.11538462,7.61904762 C2.11538462,7.70628571 2.175,7.78209524 2.26,7.80342857 C2.27576923,7.80761905 2.29192308,7.80952381 2.30769231,7.80952381 C2.37692308,7.80952381 2.44230769,7.77219048 2.47653846,7.71009524 L4.78423077,3.51961905 C4.81653846,3.46095238 4.81538462,3.38895238 4.78076923,3.33142857 Z"
                            id="Path"
                        />
                    </g>
                </g>
            </svg>
        </div>
    );
};
IconBulletFlash.propTypes = {
    size: PropTypes.number,
};

export const IconClose = ({ onClick }) => {
    return (
        <div className="icon icon14" onClick={onClick}>
            <svg
                width="14px"
                height="14px"
                viewBox="0 0 14 14"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xlinkHref="http://www.w3.org/1999/xlink"
            >
                <defs>
                    <path
                        d="M14.3,1.7 L14.3,1.7 C13.9134007,1.31340068 13.2865993,1.31340068 12.9,1.7 L8,6.6 L3.1,1.7 C2.71340068,1.31340068 2.08659932,1.31340068 1.7,1.7 L1.7,1.7 C1.31340068,2.08659932 1.31340068,2.71340068 1.7,3.1 L6.6,8 L1.7,12.9 C1.31340068,13.2865993 1.31340068,13.9134007 1.7,14.3 L1.7,14.3 C2.08659932,14.6865993 2.71340068,14.6865993 3.1,14.3 L8,9.4 L12.9,14.3 C13.2865993,14.6865993 13.9134007,14.6865993 14.3,14.3 L14.3,14.3 C14.6865993,13.9134007 14.6865993,13.2865993 14.3,12.9 L9.4,8 L14.3,3.1 C14.6865993,2.71340068 14.6865993,2.08659932 14.3,1.7 Z"
                        id="iconClose"
                    />
                </defs>
                <g id="Курс_прохождение" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g id="Home_3" transform="translate(-340.000000, -298.000000)">
                        <g id="Group-Copy" transform="translate(12.000000, 289.000000)">
                            <g id="Icons-24/cancel_24" transform="translate(327.000000, 8.000000)">
                                <g id="cancel_24">
                                    <rect
                                        id="Bounds_IconClose"
                                        opacity="0.100000001"
                                        x="0"
                                        y="0"
                                        width="16"
                                        height="16"
                                    />
                                    <mask id="mask-2_IconClose" fill="white">
                                        <use xlinkHref="#iconClose" />
                                    </mask>
                                    <use id="Icon_IconClose" fill="#C4C8CC" fillRule="nonzero" xlinkHref="#iconClose" />
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </svg>
        </div>
    );
};
IconClose.propTypes = {
    onClick: PropTypes.func,
};

export const IconClear = () => {
    return (
        <div className="icon icon24">
            <svg
                width="24px"
                height="24px"
                viewBox="0 0 16 16"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xlinkHref="http://www.w3.org/1999/xlink"
            >
                <defs>
                    <path
                        d="M6.72862294,8.0015033 L4.26290894,10.469991 C3.91143707,10.8214629 3.91143707,11.3913114 4.26290894,11.7427832 C4.6143808,12.0942551 5.18422928,12.0942551 5.53570114,11.7427832 L8.00070006,9.2750114 L10.465699,11.7427832 C10.8171708,12.0942551 11.3870193,12.0942551 11.7384912,11.7427832 C12.0899631,11.3913114 12.0899631,10.8214629 11.7384912,10.469991 L9.27277719,8.0015033 L11.7384912,5.53301559 C12.0899631,5.18154373 12.0899631,4.61169525 11.7384912,4.26022339 C11.3870193,3.90875153 10.8171708,3.90875153 10.465699,4.26022339 L8.00070006,6.72799521 L5.53570114,4.26022339 C5.18422928,3.90875153 4.6143808,3.90875153 4.26290894,4.26022339 C3.91143707,4.61169525 3.91143707,5.18154373 4.26290894,5.53301559 L6.72862294,8.0015033 Z M8,16 C3.581722,16 0,12.418278 0,8 C0,3.581722 3.581722,0 8,0 C12.418278,0 16,3.581722 16,8 C16,12.418278 12.418278,16 8,16 Z"
                        id="IconClear"
                    />
                </defs>
                <g id="ic/16/clear" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g id="clear_16">
                        <mask id="mask-2" fill="white">
                            <use xlinkHref="#IconClear" />
                        </mask>
                        <use id="Icon" fill="#AAAEB3" fillRule="nonzero" xlinkHref="#IconClear" />
                    </g>
                </g>
            </svg>
        </div>
    );
};

export const IconStar = ({ onClick, color, size, colWhite }) => {
    const colDefault = `icon icon16${color ? ' icon--active' : ''}`;
    const colWhiteVar = `icon white icon16${color ? ' icon--active' : ''}`;
    return (
        <div
            className={colWhite ? colWhiteVar : colDefault}
            style={{ width: `${size}px`, height: `${size}px` }}
            onClick={onClick}
        >
            <svg
                width={size || '24px'}
                height={size || '24px'}
                viewBox="0 0 16 16"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xlinkHref="http://www.w3.org/1999/xlink"
            >
                <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g id="Stars" transform="translate(-61.000000, -1.000000)">
                        <g id="Group-4">
                            <g id="ic/18/star/grey" transform="translate(60.000000, 0.000000)">
                                <polygon id="Path" opacity="0.4" points="0 0 18 0 18 18 0 18" />
                                <path
                                    d="M9.34425,2.46225 L11.187,6.825 L15.4215,7.242 C15.5710911,7.25686284 15.6973493,7.35962183 15.7422813,7.50307747 C15.7872133,7.64653312 15.7421343,7.80295694 15.62775,7.9005 L12.2835,10.7535 L13.4715,15.19875 C13.5122505,15.352113 13.4520594,15.5145233 13.3212033,15.6042869 C13.1903471,15.6940505 13.0171573,15.6917329 12.88875,15.5985 L8.99925,12.7785 L5.109,15.5985 C4.98058222,15.6911429 4.80781271,15.6931391 4.67728872,15.6034879 C4.54676474,15.5138368 4.48661966,15.3518619 4.527,15.19875 L5.71425,10.7535 L2.36925,7.9005 C2.25481296,7.80285816 2.20980074,7.64628112 2.25491273,7.50277268 C2.30002472,7.35926424 2.42652858,7.25660341 2.57625,7.242 L6.81,6.825 L8.6535,2.46225 C8.71218992,2.32349587 8.84821905,2.23333597 8.998875,2.23333597 C9.14953095,2.23333597 9.28556008,2.32349587 9.34425,2.46225 Z"
                                    id="Path"
                                    stroke="rgb(191, 205, 218)"
                                    strokeWidth="1.5"
                                    fill="rgb(191, 205, 218)"
                                />
                            </g>
                        </g>
                    </g>
                </g>
            </svg>
        </div>
    );
};
IconStar.propTypes = {
    onClick: PropTypes.func,
    color: PropTypes.bool,
    colWhite: PropTypes.bool,
    size: PropTypes.number,
};

export const IconStar18 = () => {
    return (
        <div className="icon icon18">
            <svg
                width="18px"
                height="18px"
                viewBox="0 0 16 16"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xlinkHref="http://www.w3.org/1999/xlink"
            >
                <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g id="Stars" transform="translate(-61.000000, -1.000000)">
                        <g id="Group-4">
                            <g id="ic/18/star/grey" transform="translate(60.000000, 0.000000)">
                                <polygon id="Path" opacity="0.4" points="0 0 18 0 18 18 0 18" />
                                <path
                                    d="M9.34425,2.46225 L11.187,6.825 L15.4215,7.242 C15.5710911,7.25686284 15.6973493,7.35962183 15.7422813,7.50307747 C15.7872133,7.64653312 15.7421343,7.80295694 15.62775,7.9005 L12.2835,10.7535 L13.4715,15.19875 C13.5122505,15.352113 13.4520594,15.5145233 13.3212033,15.6042869 C13.1903471,15.6940505 13.0171573,15.6917329 12.88875,15.5985 L8.99925,12.7785 L5.109,15.5985 C4.98058222,15.6911429 4.80781271,15.6931391 4.67728872,15.6034879 C4.54676474,15.5138368 4.48661966,15.3518619 4.527,15.19875 L5.71425,10.7535 L2.36925,7.9005 C2.25481296,7.80285816 2.20980074,7.64628112 2.25491273,7.50277268 C2.30002472,7.35926424 2.42652858,7.25660341 2.57625,7.242 L6.81,6.825 L8.6535,2.46225 C8.71218992,2.32349587 8.84821905,2.23333597 8.998875,2.23333597 C9.14953095,2.23333597 9.28556008,2.32349587 9.34425,2.46225 Z"
                                    id="Path"
                                    stroke="#D3D3D3"
                                    strokeWidth="1.5"
                                    fill="#D3D3D3"
                                />
                            </g>
                        </g>
                    </g>
                </g>
            </svg>
        </div>
    );
};

export const IconStarFilled = () => {
    return (
        <div className="icon icon14">
            <svg
                width="14px"
                height="14px"
                viewBox="0 0 14 14"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xlinkHref="http://www.w3.org/1999/xlink"
            >
                <g id="Курс_старт" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g id="Course-Program" transform="translate(-134.000000, -746.000000)">
                        <g id="Icon-Button-@Buttons.Medium" transform="translate(117.000000, 735.000000)">
                            <g id="Icons-24/fav-filled" transform="translate(16.000000, 10.000000)">
                                <g id="round-star_border-24px" transform="translate(0.000000, 0.666667)">
                                    <polygon id="Path" points="0 0 16 0 16 15.3333333 0 15.3333333" />
                                    <path
                                        d="M5.29287081,4.21921471 L6.46529198,1.56127379 C6.72485312,0.973423708 7.32914013,0.58974359 8.00026942,0.58974359 C8.67139871,0.58974359 9.27568573,0.973423708 9.53524687,1.56127379 L10.7071906,4.21921334 L13.3149033,4.46521546 C13.9807775,4.5285926 14.5408742,4.96527724 14.73935,5.57231264 C14.9370683,6.17703087 14.7386558,6.83657176 14.2334299,7.2492962 L12.1857572,8.92272833 L12.9246656,11.5713233 C13.1039998,12.2178626 12.8388877,12.9031216 12.2599753,13.2835418 C11.6773422,13.666407 10.9044733,13.6564996 10.3336216,13.2594472 L8.0004936,11.6389869 L5.66429965,13.2612607 C5.09263348,13.6563308 4.32163796,13.6648642 3.74048649,13.2824806 C3.16304506,12.902538 2.89813486,12.2191132 3.07692172,11.5697277 L3.81486729,8.9229172 L1.76642611,7.24923243 C1.26076579,6.83592546 1.06264832,6.17574162 1.26115897,5.57079957 C1.46043278,4.96353189 2.0216311,4.52725534 2.68680078,4.46510504 L5.29287081,4.21921471 Z"
                                        id="Path"
                                        fill="#5383BA"
                                        fillRule="nonzero"
                                    />
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </svg>
        </div>
    );
};

export const IconStarBorder = () => {
    return (
        <div className="icon icon14">
            <svg
                width="14px"
                height="14px"
                viewBox="0 0 14 14"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xlinkHref="http://www.w3.org/1999/xlink"
            >
                <g id="Курс_старт" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g id="Course_scroll" transform="translate(-102.000000, -746.000000)">
                        <g id="Group-7" transform="translate(0.000000, 663.000000)">
                            <g id="Icon-Button-@Buttons.Medium" transform="translate(85.000000, 72.000000)">
                                <g id="Icons-24/fav-border" transform="translate(16.000000, 10.000000)">
                                    <g id="round-star_border-24px" transform="translate(0.000000, 0.666667)">
                                        <polygon id="Path" points="0 0 16 0 16 15.3333333 0 15.3333333" />
                                        <path
                                            d="M5.29287081,4.21921471 L6.46529198,1.56127379 C6.72485312,0.973423708 7.32914013,0.58974359 8.00026942,0.58974359 C8.67139871,0.58974359 9.27568573,0.973423708 9.53524687,1.56127379 L10.7071906,4.21921334 L13.3149033,4.46521546 C13.9807775,4.5285926 14.5408742,4.96527724 14.73935,5.57231264 C14.9370683,6.17703087 14.7386558,6.83657176 14.2334299,7.2492962 L12.1857572,8.92272833 L12.9246656,11.5713233 C13.1039998,12.2178626 12.8388877,12.9031216 12.2599753,13.2835418 C11.6773422,13.666407 10.9044733,13.6564996 10.3336216,13.2594472 L8.0004936,11.6389869 L5.66429965,13.2612607 C5.09263348,13.6563308 4.32163796,13.6648642 3.74048649,13.2824806 C3.16304506,12.902538 2.89813486,12.2191132 3.07692172,11.5697277 L3.81486729,8.9229172 L1.76642611,7.24923243 C1.26076579,6.83592546 1.06264832,6.17574162 1.26115897,5.57079957 C1.46043278,4.96353189 2.0216311,4.52725534 2.68680078,4.46510504 L5.29287081,4.21921471 Z M8.27877066,2.06400219 C8.23144466,1.95681901 8.12175438,1.88717333 8.00026942,1.88717333 C7.87878447,1.88717333 7.76909419,1.95681901 7.72176819,2.06400219 L6.37555442,5.11594035 C6.28890527,5.31237858 6.10278203,5.4465846 5.88903146,5.46675259 L2.82123512,5.75620814 C2.70050373,5.76748882 2.59849438,5.84679106 2.56211727,5.9576468 C2.52574016,6.06850254 2.56203682,6.18945336 2.65431581,6.2648786 L5.05175334,8.22371182 C5.23394788,8.37257439 5.31082021,8.61512264 5.24763375,8.84175535 L4.39426813,11.9025463 C4.3617065,12.0208204 4.41020589,12.1459409 4.51545697,12.2151936 C4.62070805,12.2844462 4.7600248,12.2829043 4.86357748,12.2113405 L7.66253813,10.2677136 C7.86579054,10.1265731 8.13534463,10.1265852 8.33858429,10.2677441 L11.1369614,12.2113405 C11.2405056,12.28336 11.3801613,12.2851503 11.4856802,12.2158107 C11.5911991,12.1464712 11.6397356,12.0210144 11.6068755,11.9025463 L10.7529721,8.84176016 C10.6897455,8.61512668 10.766589,8.37255442 10.9487761,8.22366455 L13.3456183,6.2648786 C13.4378547,6.18952966 13.4742052,6.0686972 13.4379732,5.95788225 C13.4017413,5.84706729 13.29993,5.76768922 13.1793037,5.75620814 L10.1109693,5.46675309 C9.89718317,5.44658532 9.71103456,5.31234209 9.62440064,5.11585847 L8.27877066,2.06400219 Z"
                                            id="Path"
                                            fill="#5383BA"
                                            fillRule="nonzero"
                                        />
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </svg>
        </div>
    );
};

export const IconProgress = ({ size }) => {
    return (
        <div className="icon" style={{ width: `${size}px`, height: `${size}px` }}>
            <svg
                width={size}
                height={size}
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xlinkHref="http://www.w3.org/1999/xlink"
            >
                <desc>Created with Sketch.</desc>
                <g id="Курс_прохождение" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g id="Home_0" transform="translate(-351.000000, -437.000000)" fill="#DDDDDD">
                        <g id="Group-2" transform="translate(0.000000, 418.000000)">
                            <g id="Group-4">
                                <g id="Group-3" transform="translate(351.000000, 19.000000)">
                                    <circle id="ic/12/progress_0" cx={size / 2} cy={size / 2} r={size / 2} />
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </svg>
        </div>
    );
};
IconProgress.propTypes = {
    size: PropTypes.number,
};

export const IconChevron = ({ size, onClick, color }) => {
    return (
        <div className="icon" style={{ width: `${size}px`, height: `${size}px` }} onClick={onClick}>
            <svg
                width="16px"
                height="24px"
                viewBox="0 0 16 24"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xlinkHref="http://www.w3.org/1999/xlink"
            >
                <desc>Created with Sketch.</desc>
                <defs>
                    <path
                        d="M4.70577316,7.70577316 C4.31598541,7.31598541 4.31811142,6.68188858 4.70607704,6.29392296 L4.79392296,6.20607704 C5.18387854,5.81612146 5.81350851,5.81350851 6.20798751,6.20798751 L11.2920125,11.2920125 C11.6830232,11.6830232 11.6864915,12.3135085 11.2920125,12.7079875 L6.20798751,17.7920125 C5.81697681,18.1830232 5.18188858,18.1818886 4.79392296,17.793923 L4.70607704,17.706077 C4.31612146,17.3161215 4.31277239,16.6872276 4.70577316,16.2942268 L9,12 L4.70577316,7.70577316 Z"
                        id="IconChevron"
                    />
                </defs>
                <g id="ic/24/chevron" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g id="chevron_24">
                        <rect id="Bounds" x="0" y="0" width="16" height="24" />
                        <mask id="mask-2" fill="white">
                            <use xlinkHref="#IconChevron" />
                        </mask>
                        <use
                            id="Icon"
                            fill="#C4C8CC"
                            fillRule="nonzero"
                            xlinkHref="#IconChevron"
                            style={{ fill: color }}
                        />
                    </g>
                </g>
            </svg>
        </div>
    );
};
IconChevron.propTypes = {
    size: PropTypes.number,
    onClick: PropTypes.func,
    color: PropTypes.string,
};

export const IconDone = ({ size, color }) => {
    return (
        <div className="icon icon12" style={{ width: `${size}px`, height: `${size}px` }}>
            <svg
                width={size}
                height={size}
                viewBox="0 0 12 12"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xlinkHref="http://www.w3.org/1999/xlink"
            >
                <defs>
                    <path
                        d="M5.22727273,7.45522388 L3.81598474,6.13120104 C3.67025381,5.99448118 3.44338256,5.99448118 3.29765162,6.13120104 L3.27840909,6.14925373 C3.13415561,6.28458749 3.12692475,6.51123772 3.2622585,6.6554912 C3.26746895,6.66104507 3.27285522,6.66643134 3.27840909,6.67164179 L4.96810617,8.25685867 C5.1138371,8.39357852 5.34070835,8.39357852 5.48643929,8.25685867 L9.72159091,4.28358209 C9.86584439,4.14824833 9.87307525,3.9215981 9.7377415,3.77734462 C9.73253105,3.77179075 9.72714478,3.76640448 9.72159091,3.76119403 L9.70234838,3.74314133 C9.55661744,3.60642148 9.32974619,3.60642148 9.18401526,3.74314133 L5.22727273,7.45522388 Z"
                        id="IconDone"
                    />
                </defs>
                <g id="Курс_старт" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g id="Course" transform="translate(-12.000000, -1110.000000)">
                        <g id="Group-2" transform="translate(0.000000, 1046.000000)">
                            <g id="item" transform="translate(0.000000, 48.000000)">
                                <g id="ic/12/done" transform="translate(12.000000, 16.000000)">
                                    <g>
                                        <circle id="Oval" fill="#5383BA" style={{ fill: color }} cx="6" cy="6" r="6" />
                                        <mask id="mask-2" fill="white">
                                            <use xlinkHref="#IconDone" />
                                        </mask>
                                        <use
                                            id="Icon"
                                            stroke="#FFFFFF"
                                            strokeWidth="0.4"
                                            fill="#FFFFFF"
                                            fillRule="nonzero"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            xlinkHref="#IconDone"
                                        />
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </svg>
        </div>
    );
};
IconDone.propTypes = {
    size: PropTypes.number,
    color: PropTypes.string,
};

export const IconCircle = ({ size }) => {
    return (
        <div className="icon icon16" style={{ width: `${size}px`, height: `${size}px` }}>
            <svg
                width="16px"
                height="16px"
                viewBox="0 0 12 12"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xlinkHref="http://www.w3.org/1999/xlink"
            >
                <title>cirlce</title>
                <defs>
                    <path
                        d="M5.22727273,7.45522388 L3.81598474,6.13120104 C3.67025381,5.99448118 3.44338256,5.99448118 3.29765162,6.13120104 L3.27840909,6.14925373 C3.13415561,6.28458749 3.12692475,6.51123772 3.2622585,6.6554912 C3.26746895,6.66104507 3.27285522,6.66643134 3.27840909,6.67164179 L4.96810617,8.25685867 C5.1138371,8.39357852 5.34070835,8.39357852 5.48643929,8.25685867 L9.72159091,4.28358209 C9.86584439,4.14824833 9.87307525,3.9215981 9.7377415,3.77734462 C9.73253105,3.77179075 9.72714478,3.76640448 9.72159091,3.76119403 L9.70234838,3.74314133 C9.55661744,3.60642148 9.32974619,3.60642148 9.18401526,3.74314133 L5.22727273,7.45522388 Z"
                        id="path-1"
                    />
                </defs>
                <g id="Курс_старт" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g id="Course" transform="translate(-12.000000, -1110.000000)">
                        <g id="Group-2" transform="translate(0.000000, 1046.000000)">
                            <g id="item" transform="translate(0.000000, 48.000000)">
                                <g id="circle" transform="translate(12.000000, 16.000000)">
                                    <g>
                                        <circle id="Oval" fill="#dddddd" cx="6" cy="6" r="6" />
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </svg>
        </div>
    );
};
IconCircle.propTypes = {
    size: PropTypes.number,
    color: PropTypes.string,
};

export const IconDoneOut = ({ size }) => {
    return (
        <div className="icon icon24" style={{ width: `${size}px`, height: `${size}px` }}>
            <svg
                width="24px"
                height="24px"
                viewBox="0 0 24 24"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xlinkHref="http://www.w3.org/1999/xlink"
            >
                <defs>
                    <path
                        d="M8.71212121,12.4253731 L6.35997457,10.2186684 C6.11708968,9.99080197 5.73897093,9.99080197 5.49608604,10.2186684 L5.46401515,10.2487562 C5.22359269,10.4743125 5.21154124,10.8520629 5.4370975,11.0924853 C5.44578159,11.1017418 5.4547587,11.1107189 5.46401515,11.119403 L8.28289293,13.7639791 C8.52466144,13.9907982 8.9006841,13.9919815 9.1438753,13.7666885 L15.7615903,7.6360186 C16.0019069,7.41338861 16.0162448,7.03809624 15.7936148,6.79777962 C15.7841975,6.78761416 15.7744268,6.77778182 15.7643208,6.76830072 L15.7291501,6.73530473 C15.4875398,6.50863408 15.1118141,6.50728409 14.8685812,6.7322127 L8.71212121,12.4253731 Z"
                        id="IconDoneOut"
                    />
                </defs>
                <g id="ic/24/done-24-grey" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g id="ic/12/done" transform="translate(2.000000, 2.000000)">
                        <circle id="Oval" stroke="#AAAEB3" strokeWidth="2" cx="10" cy="10" r="9" />
                        <mask id="mask-2" fill="white">
                            <use xlinkHref="#IconDoneOut" />
                        </mask>
                        <use
                            id="Icon"
                            stroke="#AAAEB3"
                            strokeWidth="0.666666667"
                            fill="#AAAEB3"
                            fillRule="nonzero"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            xlinkHref="#IconDoneOut"
                        />
                    </g>
                </g>
            </svg>
        </div>
    );
};
IconDoneOut.propTypes = {
    size: PropTypes.number,
};

export const IconShare = ({ size, color }) => {
    return (
        <div className="icon icon24" style={{ width: `${size}px`, height: `${size}px` }}>
            <svg
                width="24px"
                height="18px"
                viewBox="0 0 24 18"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xlinkHref="http://www.w3.org/1999/xlink"
            >
                <g id="Курс_прохождение" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g id="Training_final_course" transform="translate(-64.000000, -501.000000)">
                        <g id="button" transform="translate(64.000000, 498.000000)">
                            <g id="Icons-24/share_outline">
                                <g id="share_outline">
                                    <polygon id="Shape" points="0 0 24 0 24 24 0 24" />
                                    <path
                                        style={{ fill: color }}
                                        d="M0.321834981,18.2495767 C1.84764179,11.6877421 5.83120958,8.17390528 12.1000008,7.87136065 L12.1000008,4.40209199 C12.1000008,3.67464264 12.689715,3.08492842 13.4171643,3.08492842 C13.7297143,3.08492842 14.0320797,3.19607109 14.2702237,3.39849367 L23.2089396,10.9964093 C23.7632117,11.4675409 23.8306103,12.2987949 23.3594786,12.853067 C23.3134428,12.9072266 23.2630985,12.957571 23.2089387,13.0036067 L14.2702228,20.6015082 C13.7159503,21.0726394 12.8846964,21.00524 12.4135652,20.4509675 C12.2111431,20.2128237 12.1000008,19.9104586 12.1000008,19.5979091 L12.1000008,16.161459 C7.45347839,16.2819309 4.18439719,17.3511563 2.26406363,19.3142206 C1.82014712,19.7682929 1.09187506,19.7763489 0.637786974,19.3321451 C0.350627046,19.0512359 0.23085366,18.6408479 0.321834981,18.2495767 Z M13.0000007,9.64999998 C7.73797159,9.64999998 4.3311518,11.9582964 2.6417516,16.7052975 C5.09639443,15.1238524 8.55497054,14.35 13.0000007,14.35 L13.9000007,14.35 L13.9000007,18.5538048 L21.6103579,12.0000072 L13.9000007,5.44619754 L13.9000007,9.64999998 L13.0000007,9.64999998 Z"
                                        id="Mask"
                                        fill="#5383BA"
                                        fillRule="nonzero"
                                    />
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </svg>
        </div>
    );
};
IconShare.propTypes = {
    size: PropTypes.number,
    color: PropTypes.string,
};

export const IconInfo = ({ size }) => {
    return (
        <div className="icon icon18" style={{ width: `${size}px`, height: `${size}px` }}>
            <svg
                width="18px"
                height="18px"
                viewBox="0 0 18 18"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xlinkHref="http://www.w3.org/1999/xlink"
            >
                <g id="Курс_старт" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g id="Author" transform="translate(-12.000000, -285.000000)">
                        <g id="Group-4" transform="translate(0.000000, 88.000000)">
                            <g id="Item">
                                <g id="additional" transform="translate(12.000000, 197.000000)">
                                    <g id="ic/18/info">
                                        <circle id="Oval" fill="#5383BA" cx="9" cy="9" r="9" />
                                        <circle id="Oval" fill="#FFFFFF" cx="9" cy="6.25" r="1.25" />
                                        <rect id="Rectangle" fill="#FFFFFF" x="8" y="8.5" width="2" height="6" rx="1" />
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </svg>
        </div>
    );
};
IconInfo.propTypes = {
    size: PropTypes.number,
};

export const IconMainZero = ({ size }) => {
    return (
        <div className="icon icon52" style={{ width: `${size}px`, height: `${size}px` }}>
            <svg
                width="52px"
                height="52px"
                viewBox="0 0 52 52"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xlinkHref="http://www.w3.org/1999/xlink"
            >
                <g id="Профиль" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g id="Archive_zero" transform="translate(-162.000000, -249.000000)">
                        <g id="ic/56/main_zero" transform="translate(160.000000, 247.000000)">
                            <rect id="Rectangle" x="0" y="0" width="56" height="56" />
                            <path
                                d="M24.88,38.14 L37.022,29.04 C37.724,28.52 37.724,27.48 37.022,26.96 L24.88,17.86 C24.022,17.21 22.8,17.834 22.8,18.9 L22.8,37.1 C22.8,38.166 24.022,38.79 24.88,38.14 Z M28,2 C13.648,2 2,13.648 2,28 C2,42.352 13.648,54 28,54 C42.352,54 54,42.352 54,28 C54,13.648 42.352,2 28,2 Z M28,48.8 C16.534,48.8 7.2,39.466 7.2,28 C7.2,16.534 16.534,7.2 28,7.2 C39.466,7.2 48.8,16.534 48.8,28 C48.8,39.466 39.466,48.8 28,48.8 Z"
                                id="Shape"
                                fill="#4076B3"
                                fillRule="nonzero"
                            />
                        </g>
                    </g>
                </g>
            </svg>
        </div>
    );
};
IconMainZero.propTypes = {
    size: PropTypes.number,
};

export const IconNotifTrain = ({ size }) => {
    return (
        <div className="icon icon28" style={{ width: `${size}px`, height: `${size}px` }}>
            <svg
                width="28px"
                height="28px"
                style={{ width: `${size}px`, height: `${size}px` }}
                viewBox="0 0 28 28"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xlinkHref="http://www.w3.org/1999/xlink"
            >
                <g id="Профиль" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g id="Alerts" transform="translate(-16.000000, -102.000000)">
                        <g id="Item" transform="translate(0.000000, 88.000000)">
                            <g id="ic/28/notifications_trainings" transform="translate(16.000000, 14.000000)">
                                <circle id="Oval-54-Copy-2" fill="#5C9CE6" cx="14" cy="14" r="14" />
                                <g
                                    id="round-play_circle_outline-24px"
                                    transform="translate(6.000000, 6.000000)"
                                    fill="#FFFFFF"
                                    fillRule="nonzero"
                                >
                                    <path
                                        d="M7.04,11.12 L10.776,8.32 C10.992,8.16 10.992,7.84 10.776,7.68 L7.04,4.88 C6.776,4.68 6.4,4.872 6.4,5.2 L6.4,10.8 C6.4,11.128 6.776,11.32 7.04,11.12 Z M8,0 C3.584,0 0,3.584 0,8 C0,12.416 3.584,16 8,16 C12.416,16 16,12.416 16,8 C16,3.584 12.416,0 8,0 Z M8,14.4 C4.472,14.4 1.6,11.528 1.6,8 C1.6,4.472 4.472,1.6 8,1.6 C11.528,1.6 14.4,4.472 14.4,8 C14.4,11.528 11.528,14.4 8,14.4 Z"
                                        id="Shape"
                                    />
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </svg>
        </div>
    );
};
IconNotifTrain.propTypes = {
    size: PropTypes.number,
};

export const IconNotifNew = ({ size }) => {
    return (
        <div className="icon icon28" style={{ width: `${size}px`, height: `${size}px` }}>
            <svg
                width="28px"
                height="28px"
                viewBox="0 0 28 28"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xlinkHref="http://www.w3.org/1999/xlink"
            >
                <g id="Профиль" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g id="Alerts" transform="translate(-16.000000, -158.000000)">
                        <g id="Item" transform="translate(0.000000, 144.000000)">
                            <g id="ic/28/notifications_new" transform="translate(16.000000, 14.000000)">
                                <circle id="Oval-54" fill="#4BB34B" cx="14" cy="14" r="14" />
                                <g
                                    id="round-play_circle_outline-24px"
                                    transform="translate(5.000000, 5.000000)"
                                    fill="#FFFFFF"
                                >
                                    <path
                                        d="M9,0 C4.032,0 0,4.032 0,9 C0,13.968 4.032,18 9,18 C13.968,18 18,13.968 18,9 C18,4.032 13.968,0 9,0 Z M9,16.2 C5.031,16.2 1.8,12.969 1.8,9 C1.8,5.031 5.031,1.8 9,1.8 C12.969,1.8 16.2,5.031 16.2,9 C16.2,12.969 12.969,16.2 9,16.2 Z"
                                        id="Shape"
                                        fillRule="nonzero"
                                    />
                                    <rect id="Rectangle-82-Copy" x="4" y="8" width="10" height="2" rx="1" />
                                    <rect id="Rectangle-82-Copy" x="8" y="4" width="2" height="10" rx="1" />
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </svg>
        </div>
    );
};
IconNotifNew.propTypes = {
    size: PropTypes.number,
};

export const IconSelect = ({ size }) => {
    return (
        <div className="icon icon24" style={{ width: `${size}px`, height: `${size}px` }}>
            <svg
                width="18px"
                height="13px"
                viewBox="0 0 18 13"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xlinkHref="http://www.w3.org/1999/xlink"
            >
                <defs>
                    <path
                        d="M8.9999939,16.2 L5.4999939,12.7 C5.11339457,12.3134007 4.48659322,12.3134007 4.0999939,12.7 L4.0999939,12.7 C3.71339457,13.0865993 3.71339457,13.7134007 4.0999939,14.1 L8.29288712,18.2928932 C8.68341141,18.6834175 9.31657639,18.6834175 9.70710068,18.2928932 L20.2999939,7.7 C20.6865932,7.31340068 20.6865932,6.68659932 20.2999939,6.3 L20.2999939,6.3 C19.9133946,5.91340068 19.2865932,5.91340068 18.8999939,6.3 L8.9999939,16.2 Z"
                        id="IconSelect"
                    />
                </defs>
                <g id="Регистрация" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g id="Onboarding_2" transform="translate(-342.000000, -424.000000)">
                        <g id="List-Selecting-@Tables.General" transform="translate(0.000000, 406.000000)">
                            <g id="Item">
                                <g id="Icons-24/done_24" transform="translate(339.000000, 12.000000)">
                                    <g id="done_24">
                                        <rect id="Bounds" opacity="0.100000001" x="0" y="0" width="24" height="24" />
                                        <mask id="mask-2" fill="white">
                                            <use xlinkHref="#IconSelect" />
                                        </mask>
                                        <use id="Icon" fill="#528BCC" fillRule="nonzero" xlinkHref="#IconSelect" />
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </svg>
        </div>
    );
};
IconSelect.propTypes = {
    size: PropTypes.number,
};

export const IconTarget = ({ size }) => {
    return (
        <div className="icon icon24" style={{ width: `${size}px`, height: `${size}px` }}>
            <svg
                width="24px"
                height="24px"
                viewBox="0 0 24 24"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xlinkHref="http://www.w3.org/1999/xlink"
            >
                <g id="ic/24/aim" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g
                        id="noun_Target_2603101"
                        transform="translate(2.000000, 0.000000)"
                        fill="#AAAEB3"
                        fillRule="nonzero"
                    >
                        <path
                            d="M15.1956,9.3496 C15.82992,10.42168 16.20072,11.66656 16.20072,12.99928 C16.20072,16.96936 12.9708,20.19928 9.00072,20.19928 C5.03064,20.19928 1.80072,16.96936 1.80072,12.99928 C1.80072,9.0292 5.03064,5.79928 9.00072,5.79928 C10.33416,5.79928 11.57904,6.17008 12.6504,6.8044 L13.95936,5.49472 C12.53592,4.5508 10.83168,4 9,4 C4.03704,4 0,8.03704 0,13 C0,17.96296 4.03704,22 9,22 C13.96296,22 18,17.96296 18,13 C18,11.16832 17.44848,9.46336 16.50528,8.04064 L15.1956,9.3496 Z"
                            id="Path"
                        />
                        <path
                            d="M9,9.78954903 C9.21188261,9.78954903 9.41875447,9.81173944 9.61846815,9.85110952 L11.0336435,8.43664996 C10.4115963,8.15819613 9.72440945,8 9,8 C6.24266285,8 4,10.2433787 4,13 C4,15.7573372 6.24337867,18 9,18 C11.7566213,18 14,15.7573372 14,13 C14,12.2755906 13.8418039,11.5891195 13.5640659,10.9670723 L12.1488905,12.3815319 C12.1889764,12.5819613 12.210451,12.7881174 12.210451,13 C12.210451,14.7709377 10.7702219,16.210451 9,16.210451 C7.2297781,16.210451 5.78954903,14.7702219 5.78954903,13 C5.78883321,11.2304939 7.22906228,9.78954903 9,9.78954903 Z"
                            id="Path"
                        />
                        <path
                            d="M21.610875,3.1081875 C21.5235625,2.8593125 21.3021875,2.68125 21.04025,2.6516875 L19.5229375,2.4770625 L19.3483125,0.95975 C19.31875,0.6978125 19.141375,0.47575 18.8918125,0.3884375 C18.6429375,0.3025 18.365875,0.3650625 18.1795625,0.551375 L15.2625,3.469125 C15.1421875,3.5894375 15.0706875,3.749625 15.06175,3.9194375 L14.950375,6.0768125 L8.459,12.5681875 C8.1901875,12.837 8.1901875,13.2721875 8.459,13.5403125 C8.5930625,13.674375 8.7690625,13.74175 8.9450625,13.74175 C9.1210625,13.74175 9.29775,13.674375 9.431125,13.5403125 L15.9225,7.0489375 L18.079875,6.9375625 C18.2496875,6.928625 18.409875,6.8578125 18.5301875,6.7368125 L21.44725,3.81975 C21.63425,3.634125 21.6975,3.3570625 21.610875,3.1081875 Z"
                            id="Path"
                        />
                    </g>
                </g>
            </svg>
        </div>
    );
};
IconTarget.propTypes = {
    size: PropTypes.number,
};

export const IconNotification = ({ size }) => {
    return (
        <div className="icon icon24" style={{ width: `${size}px`, height: `${size}px` }}>
            <svg
                width="24px"
                height="24px"
                viewBox="0 0 24 24"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xlinkHref="http://www.w3.org/1999/xlink"
            >
                <defs>
                    <path
                        d="M17.1389119,11.9203892 L17.1428571,10.3533835 C17.1428571,7.1657795 14.9045426,4.71428571 12.0039452,4.71428571 C9.10144534,4.71428571 6.85714286,7.1678184 6.85714286,10.3533835 L6.85714286,11.9203892 C6.85714286,12.7155848 6.52765851,13.3061987 5.81863639,14.1422364 C5.75578794,14.2163436 5.69646151,14.2852276 5.577573,14.4227951 C4.92610417,15.1779342 4.71428571,15.5353805 4.71428571,15.9327731 C4.71428571,16.1265881 4.72797359,16.2298376 4.77249815,16.3245395 C4.87872032,16.5504698 5.19049687,16.7142857 6,16.7142857 L18,16.7142857 C18.7836314,16.7142857 19.1025292,16.5494099 19.2195115,16.3193078 C19.2701543,16.2196943 19.2857143,16.1133784 19.2857143,15.9327731 C19.2857143,15.5358135 19.0735265,15.178402 18.4209641,14.4233853 C18.3018566,14.2858178 18.2424222,14.2169352 18.1794592,14.1428294 C17.4690422,13.3066863 17.1389119,12.7160021 17.1389119,11.9203892 Z M15.7706221,18.4285714 C15.1982261,20.3693763 13.8964702,21.4285714 12,21.4285714 C10.1035298,21.4285714 8.80177393,20.3693763 8.22937787,18.4285714 L6,18.4285714 C4.57271209,18.4285714 3.63602535,17.9364106 3.22112136,17.0539267 C3.04116005,16.6711562 3,16.3606806 3,15.9327731 C3,14.9785514 3.3640744,14.3641711 4.27956986,13.30299 C4.39877658,13.1650393 4.45329859,13.1017338 4.51121315,13.0334443 C4.97289104,12.4890605 5.14285714,12.1843895 5.14285714,11.9203892 L5.14285714,10.3533835 C5.14285714,6.25346731 8.11887812,3 12.0039452,3 C15.8878801,3 18.8571429,6.25205816 18.8571401,10.3555415 L18.8531982,11.9212358 C18.8535624,12.1846245 19.0239323,12.4891555 19.4858757,13.0328513 C19.5438981,13.1011422 19.5985217,13.1644491 19.7179478,13.3023997 C20.6352346,14.3637033 21,14.9781183 21,15.9327731 C21,16.3622525 20.9511713,16.6958813 20.7476508,17.0962028 C20.3139085,17.9493665 19.3870447,18.4285714 18,18.4285714 L15.7706221,18.4285714 Z M13.9540704,18.4285714 L10.0459296,18.4285714 C10.4322996,19.3225186 11.0557514,19.7142858 12,19.7142858 C12.9442486,19.7142858 13.5677004,19.3225186 13.9540704,18.4285714 Z"
                        id="IconNotification"
                    />
                </defs>
                <g id="ic/24/notification" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g id="notifications_28">
                        <rect id="Icon" opacity="0.0399999991" x="0" y="0" width="24" height="24" />
                        <mask id="mask-2" fill="white">
                            <use xlinkHref="#IconNotification" />
                        </mask>
                        <use id="Icon" fill="#AAAEB3" fillRule="nonzero" xlinkHref="#IconNotification" />
                    </g>
                </g>
            </svg>
        </div>
    );
};
IconNotification.propTypes = {
    size: PropTypes.number,
};
